import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-policy',
  imports: [
    RouterLink
  ],
  templateUrl: './policy.html',
  styleUrl: './policy.scss'
})
export class Policy {

}
